import { render } from "./ItemsItem.vue?vue&type=template&id=79b52ad2&scoped=true"
import script from "./ItemsItem.vue?vue&type=script&lang=js"
export * from "./ItemsItem.vue?vue&type=script&lang=js"

import "./ItemsItem.vue?vue&type=style&index=0&id=79b52ad2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b52ad2"]])

export default __exports__
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlideItem,QIcon,QItem,QItemSection,QImg,QAvatar,QItemLabel,QChip,QBtn,QTooltip});
